'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Component", "defaultValue", "description", "error", "helpKeySuffix", "hideLabel", "keyPrefix", "messageKeySuffix", "name", "onChange", "placeholder", "placeholderKeySuffix", "placeholderOptions", "required", "validationMessage", "value"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import text from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Field extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        Component,
        defaultValue,
        description,
        error,
        helpKeySuffix,
        hideLabel,
        keyPrefix,
        messageKeySuffix,
        name,
        onChange,
        placeholder,
        placeholderKeySuffix,
        placeholderOptions,
        required,
        validationMessage,
        value
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const label = messageKeySuffix ? text(`${keyPrefix}.${messageKeySuffix}`) : '';
    const help = helpKeySuffix ? text(`${keyPrefix}.${helpKeySuffix}`) : undefined;
    const resolvedPlaceholder = placeholderKeySuffix ? text(`${keyPrefix}.${placeholderKeySuffix}`, placeholderOptions) : undefined;
    const resolvedSupportedProducts = description ? text(`${keyPrefix}.${description}`) : undefined;
    const wrapperProps = {
      error: error || false,
      help,
      required,
      validationMessage
    };
    if (hideLabel) {
      wrapperProps['aria-label'] = label;
    } else {
      wrapperProps.label = label;
    }
    wrapperProps.description = resolvedSupportedProducts;
    const variantComponentProps = {};

    // check if Component is Checkbox without using Component.type
    const isCheckbox = Component === Checkbox;
    if (!isCheckbox) {
      variantComponentProps.error = error;
    }
    const combinedComponentProps = Object.assign({}, rest, variantComponentProps, {
      defaultValue: value ? undefined : defaultValue,
      name,
      onChange: evt => onChange(evt, name),
      placeholder: placeholder || resolvedPlaceholder,
      value: value || ''
    });
    return /*#__PURE__*/_jsx(FormControl, Object.assign({}, wrapperProps, {
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, combinedComponentProps))
    }));
  }
}
Field.defaultProps = {
  Component: TextInput,
  hideLabel: false
};
Field.propTypes = {
  Component: PropTypes.elementType.isRequired,
  description: PropTypes.string,
  error: PropTypes.bool,
  helpKeySuffix: PropTypes.string,
  hideLabel: PropTypes.bool,
  keyPrefix: PropTypes.string.isRequired,
  messageKeySuffix: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.node,
  placeholderKeySuffix: PropTypes.string,
  placeholderOptions: PropTypes.object,
  required: PropTypes.bool,
  validationMessage: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  wrapperProps: PropTypes.object,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};